import React from 'react';
import { motion } from 'framer-motion';
import { GraduationCap, Clock, Check, MessageCircle } from 'lucide-react';
const courses = ['Curso de Maquillaje Profesional', 'Curso de Peinados & Styling', 'Colorimetría Avanzada', 'Tratamientos Capilares'];
interface Course {
  name: string;
  price: string;
  priceNote?: string;
  duration?: string;
  includes: string[];
  featured?: boolean;
  image: string;
  imageAlt: string;
  insetImage?: string;
  insetAlt?: string;
}
const coursePlans: Course[] = [{
  name: 'Automaquillaje y Peinado',
  price: '$400',
  duration: '1 día — 5 horas',
  includes: ['Set de Brochas', 'Kit de Maquillaje', 'Brunch', 'Práctica en maniquís'],
  featured: true,
  image: 'https://cdn.magicpatterns.com/uploads/2nddq5GepbtM8Ru839SeBV/MAQUILLAJE_CURSO.png',
  imageAlt: 'Alumna practicando automaquillaje frente a espejo iluminado en la academia',
  insetImage: 'https://cdn.magicpatterns.com/uploads/vXkQteYKEdrqZuCvk9pLvw/MAQUILLAJE_4.png',
  insetAlt: 'Set de brochas y kit de maquillaje Ginger Briones Studio incluido en el curso'
}, {
  name: 'Colorimetría',
  price: '$800',
  priceNote: 'desde',
  includes: ['Programa personalizado', 'Certificación profesional'],
  image: 'https://cdn.magicpatterns.com/uploads/bDLuj8vTRtP5naShsN8nY1/COLOMETRIA.png',
  imageAlt: 'Clase de colorimetría con muestrario de tonos y preparación de color'
}, {
  name: 'Alisado',
  price: '$500',
  priceNote: 'desde',
  includes: ['Programa personalizado', 'Certificación profesional'],
  image: 'https://cdn.magicpatterns.com/uploads/hjy2N5nyP3qVc6yvpZbaK9/CURSO_ALISADO.png',
  imageAlt: 'Demostración de técnica de alisado profesional en la academia'
}];
export function Academy() {
  return <section id="academia" className="max-w-2xl mx-auto px-6 pt-16 scroll-mt-24" data-id="element-15" data-mp="3as3z1o7lr9hp">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.7
    }} className="relative bg-dark text-cream p-9 sm:p-11 overflow-hidden" data-id="element-16" data-mp="2dc6m6mhqv6pm">
        <span aria-hidden className="pointer-events-none absolute -top-8 left-5 font-serif text-[160px] leading-none text-gold/[0.08] select-none" data-id="element-17" data-mp="25b8nkglnn1gf">
          &ldquo;
        </span>

        <div className="relative z-10" data-id="element-18" data-mp="2k1pnfvin5jb7">
          <div className="flex items-center gap-3 mb-4" data-id="element-19" data-mp="2f0igtzs8iq64">
            <GraduationCap className="w-5 h-5 text-gold-light" strokeWidth={1.5} data-id="element-20" data-mp="2f34pk2qv3bpx" />
            <p className="font-body font-medium text-[10px] tracking-[5px] uppercase text-gold-light" data-id="element-21" data-mp="1rdabjhut3h43">
              Ginger Briones Studio — Academia
            </p>
          </div>

          <h3 className="font-serif font-light text-warm-white text-2xl sm:text-[28px] leading-snug mb-4" data-id="element-22" data-mp="21ayjxalc4n4q">
            ¿Quieres convertir
            <br data-id="element-23" data-mp="3coit8saw18s2" />
            tu pasión en <em className="italic text-gold-light" data-id="element-24" data-mp="3cnr7e973epez">profesión?</em>
          </h3>

          <p className="font-body font-light text-cream/75 text-sm leading-[1.85] mb-6" data-id="element-25" data-mp="37ppnjm1uem2g">
            La academia de Ginger Briones Studio está diseñada para mujeres que quieren aprender de
            las mejores técnicas de la industria — con formación práctica, personalizada y con
            certificación profesional. Aprende desde cero o perfecciona lo que ya sabes.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5" data-id="element-26" data-mp="3a9vvs5xhoyot">
            {courses.map(course => <div key={course} className="flex items-center gap-3 px-4 py-3 bg-gold/[0.12] border border-gold/25" data-id="element-27" data-mp="3abozbcct32sl">
                <span className="w-1.5 h-1.5 rounded-full bg-gold-light flex-shrink-0" data-id="element-28" data-mp="6svr7f2sr65t" />
                <span className="font-body text-warm-white text-xs tracking-[0.3px]" data-id="element-29" data-mp="3p74nx1uma6hl">
                  {course}
                </span>
              </div>)}
          </div>

          <div className="mt-11" data-id="element-30" data-mp="3t6wxnhvqyioj">
            <div className="flex items-center gap-4 mb-7" data-id="element-31" data-mp="kt6hoh072iqg">
              <span aria-hidden className="h-px w-8 bg-gold/40" data-id="element-32" data-mp="krn3cvy3mhrb" />
              <p className="font-body font-medium text-[10px] tracking-[5px] uppercase text-gold-light" data-id="element-33" data-mp="pkojt8dyepd0">
                Inversión
              </p>
              <span aria-hidden className="h-px flex-1 bg-gold/20" data-id="element-34" data-mp="2xycwe4kl1g3t" />
            </div>

            <ul className="space-y-3" data-id="element-35" data-mp="2t3pguv7k3w1d">
              {coursePlans.map((course, i) => <motion.li key={course.name} initial={{
              opacity: 0,
              y: 14
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-40px'
            }} transition={{
              duration: 0.55,
              delay: 0.08 * i
            }} className={`relative p-6 sm:p-7 border ${course.featured ? 'bg-gold/[0.10] border-gold/40' : 'bg-warm-white/[0.03] border-gold/15'}`} data-id="element-36" data-mp="2o3b81ay4si2a" data-mpi={i}>
                  {course.featured && <span className="absolute -top-[9px] left-6 bg-gold-light text-dark font-body font-medium text-[9px] tracking-[3px] uppercase px-3 py-1 z-20" data-id="element-37" data-mp="32zk4k4qn0hb0">
                      Más solicitado
                    </span>}

                  <div className="group relative mb-6 -mx-6 -mt-6 sm:-mx-7 sm:-mt-7 overflow-hidden" data-id="element-38" data-mp="1h8c2h8modi2x">
                    <motion.div initial={{
                  clipPath: 'inset(0 0 100% 0)'
                }} whileInView={{
                  clipPath: 'inset(0 0 0% 0)'
                }} viewport={{
                  once: true,
                  margin: '-40px'
                }} transition={{
                  duration: 1.05,
                  ease: [0.22, 1, 0.36, 1],
                  delay: 0.08 * i
                }} className={`relative overflow-hidden bg-dark ${course.featured ? 'aspect-[4/5] sm:aspect-[1/1]' : 'aspect-[4/5] sm:aspect-[5/5]'}`} data-id="element-39" data-mp="1m7f9uzq4o0e2">
                      <motion.img src={course.image} alt={course.imageAlt} loading="lazy" initial={{
                    scale: 1.16
                  }} whileInView={{
                    scale: 1
                  }} viewport={{
                    once: true,
                    margin: '-40px'
                  }} transition={{
                    duration: 1.8,
                    ease: [0.22, 1, 0.36, 1],
                    delay: 0.08 * i
                  }} className="absolute inset-0 w-full h-full object-cover object-[50%_35%] transition-transform duration-[1200ms] ease-out group-hover:scale-[1.05]" data-id="element-40" data-mp="29yavff3zpzcv" />

                      <div aria-hidden className="absolute inset-0 bg-gradient-to-t from-dark via-dark/15 to-transparent" data-id="element-41" data-mp="xl4c1oto300k" />

                      <span aria-hidden className="pointer-events-none absolute inset-3 border border-gold-light/30 transition-all duration-700 group-hover:inset-2 group-hover:border-gold-light/60" data-id="element-42" data-mp="ssb83360vvpj" />

                      {course.insetImage && <motion.img src={course.insetImage} alt={course.insetAlt} loading="lazy" initial={{
                    opacity: 0,
                    y: 18,
                    rotate: -3
                  }} whileInView={{
                    opacity: 1,
                    y: 0,
                    rotate: -3
                  }} viewport={{
                    once: true,
                    margin: '-40px'
                  }} transition={{
                    duration: 0.8,
                    delay: 0.65,
                    ease: [0.22, 1, 0.36, 1]
                  }} className="absolute bottom-5 right-5 w-20 sm:w-28 aspect-[3/4] object-cover shadow-[0_10px_30px_rgba(0,0,0,0.45)] border border-gold-light/40 transition-transform duration-700 group-hover:rotate-0 group-hover:-translate-y-1" data-id="element-43" data-mp="1gj6utlvmg0px" />}
                    </motion.div>
                  </div>

                  <div className="relative z-10 flex flex-wrap items-baseline justify-between gap-x-6 gap-y-2" data-id="element-44" data-mp="1a1wwk93kqvdc">
                    <div data-id="element-45" data-mp="1f3mca21qrx7r">
                      <h4 className="font-serif font-light text-warm-white text-xl sm:text-[22px] leading-tight" data-id="element-46" data-mp="1ezykb7by3iv5">
                        {course.name}
                      </h4>
                      {course.duration && <p className="flex items-center gap-2 mt-2 font-body font-light text-cream/60 text-[11px] tracking-[1.5px] uppercase" data-id="element-47" data-mp="155y7ejaf99bv">
                          <Clock className="w-3.5 h-3.5 text-gold-light" strokeWidth={1.5} data-id="element-48" data-mp="2zi4rk7lan0gb" />
                          {course.duration}
                        </p>}
                    </div>

                    <p className="flex items-baseline gap-1.5" data-id="element-49" data-mp="1i8wrqmm5ogcp">
                      {course.priceNote && <span className="font-body font-light text-cream/50 text-[10px] tracking-[2px] uppercase" data-id="element-50" data-mp="1digdj0aigqpa">
                          {course.priceNote}
                        </span>}
                      <span className="font-serif font-light text-gold-light text-[30px] leading-none" data-id="element-51" data-mp="13kk3ycx823ta">
                        {course.price}
                      </span>
                    </p>
                  </div>

                  <div className="mt-5 pt-5 border-t border-gold/15" data-id="element-52" data-mp="ujc61vymb4zq">
                    <ul className="flex flex-wrap gap-x-6 gap-y-2.5" data-id="element-53" data-mp="uloxr0u6gtpz">
                      {course.includes.map(item => <li key={item} className="flex items-center gap-2" data-id="element-54" data-mp="pn3yb3mr2e2l">
                          <Check className="w-3.5 h-3.5 text-gold-light flex-shrink-0" strokeWidth={2} data-id="element-55" data-mp="2ox3o9jv0ix6s" />
                          <span className="font-body font-light text-cream/80 text-xs tracking-[0.3px]" data-id="element-56" data-mp="2jzlghwsqeo0d">
                            {item}
                          </span>
                        </li>)}
                    </ul>
                  </div>
                </motion.li>)}
            </ul>

            <div className="mt-8 flex flex-col items-start gap-4" data-id="element-57" data-mp="318wbmb64bt16">
              <motion.a href="https://wa.me/13478886047?text=Hola%20Ginger%2C%20quiero%20informaci%C3%B3n%20sobre%20los%20cursos%20de%20la%20academia." target="_blank" rel="noreferrer" whileHover={{
              y: -2
            }} whileTap={{
              scale: 0.97
            }} transition={{
              duration: 0.25,
              ease: [0.22, 1, 0.36, 1]
            }} className="metallic-reserve-button inline-flex items-center gap-3 px-9 py-4 text-white font-body font-semibold text-[10px] tracking-[4px] uppercase outline-none focus-visible:ring-2 focus-visible:ring-gold-light focus-visible:ring-offset-2 focus-visible:ring-offset-dark sm:px-11" data-id="element-58" data-mp="3665xjguatmk9">
                <MessageCircle className="w-4 h-4" strokeWidth={1.75} aria-hidden data-id="element-59" data-mp="2kq44g7oun1sn" />
                Consultar sobre los cursos
              </motion.a>

              <p className="font-body font-light text-cream/45 text-[11px] leading-relaxed italic" data-id="element-60" data-mp="2oq63sa743j4r">
                Cupos limitados por grupo. Precios sujetos a disponibilidad de fechas — escríbenos
                para reservar tu lugar.
              </p>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}